import { Stack, Tab, Tabs, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetTitrationsQuery } from "src/api/services/titrationApi";
import TitrationsTable from "src/components/TitrationsTable";
import { ORDER, PRODUCT } from "src/constants/searchParams";

type Tab = {
  index: number;
  label: string;
  value: string;
};

const tabs = [
  {
    label: "Semaglutide",
    value: "st",
  },
  {
    label: "Semaglutide OT",
    value: "st-ot",
  },
  {
    label: "Tirzepatide",
    value: "tr",
  },
  {
    label: "Tirzepatide OT",
    value: "tr-ot",
  },
];

const TitrationsManagement = () => {
  const [params, setSearchParams] = useSearchParams();

  const currentTab = useMemo(
    () => tabs.findIndex((t) => params.get(PRODUCT) === t.value),
    [params],
  );
  const [value, setValue] = useState<number>(currentTab);

  const query = useMemo(
    () => ({
      product: params.get(PRODUCT) ?? undefined,
      ascending: params.get(ORDER) === "asc" ? true : false,
    }),
    [params],
  );

  const { data: monthlyTitrations = [], isLoading: loadingMonthly } =
    useGetTitrationsQuery({
      ...query,
      duration: 1,
    });
  const { data: quarterlyTitrations = [], isLoading: loadingQuarterly } =
    useGetTitrationsQuery({
      ...query,
      duration: 3,
    });

  const handleChange = useCallback(
    (_: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);

      params.set(PRODUCT, tabs[newValue].value);
      setSearchParams(params);
    },
    [params, setSearchParams],
  );

  return (
    <Stack gap="32px">
      <Typography variant="h4" fontWeight={600}>
        Titrations Management
      </Typography>
      <Tabs value={value} onChange={handleChange}>
        {tabs.map((tab) => (
          <Tab
            label={tab.label}
            key={tab.label}
            sx={{ minWidth: 150, px: 3 }}
          />
        ))}
      </Tabs>
      <Stack direction={"row"} spacing={3}>
        <TitrationsTable
          titrations={monthlyTitrations}
          variant="Monthly"
          loading={loadingMonthly}
        />
        <TitrationsTable
          titrations={quarterlyTitrations}
          variant="Quarterly"
          loading={loadingQuarterly}
        />
      </Stack>
    </Stack>
  );
};

export default TitrationsManagement;
